type EventCallback<T> = (payload: T) => void;

class EventEmitter<T extends Record<string, unknown>> {
    private listeners: Map<keyof T, Set<EventCallback<T[keyof T]>>>;

    constructor() {
        this.listeners = new Map();
    }

    on<K extends keyof T>(event: K, callback: EventCallback<T[K]>) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, new Set());
        }
        const listeners = this.listeners.get(event)!;
        listeners.add(callback as EventCallback<T[keyof T]>);

        return () => this.off(event, callback);
    }

    off<K extends keyof T>(event: K, callback: EventCallback<T[K]>) {
        this.listeners.get(event)?.delete(callback as EventCallback<T[keyof T]>);
    }

    emit<K extends keyof T>(event: K, payload: T[K]) {
        const listeners = this.listeners.get(event);
        if (listeners) {
            for (const callback of listeners) {
                callback(payload);
            }
        }
    }
}

export const createEventEmitter = <T extends Record<string, unknown>>() => new EventEmitter<T>();
